import createIcon from '../../createIcon';

/**
 * @component @name Sync
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNFYxTDggNUwxMiA5VjZDMTUuMzEgNiAxOCA4LjY5IDE4IDEyQzE4IDEzLjAxIDE3Ljc1IDEzLjk3IDE3LjMgMTQuOEwxOC43NiAxNi4yNkMxOS41NCAxNS4wMyAyMCAxMy41NyAyMCAxMkMyMCA3LjU4IDE2LjQyIDQgMTIgNFpNMTIgMThDOC42OSAxOCA2IDE1LjMxIDYgMTJDNiAxMC45OSA2LjI1IDEwLjAzIDYuNyA5LjJMNS4yNCA3Ljc0QzQuNDYgOC45NyA0IDEwLjQzIDQgMTJDNCAxNi40MiA3LjU4IDIwIDEyIDIwVjIzTDE2IDE5TDEyIDE1VjE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sync = createIcon('Sync', [
  [
    'path',
    {
      d: 'M12 4V1L8 5L12 9V6C15.31 6 18 8.69 18 12C18 13.01 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 10.99 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 16.42 7.58 20 12 20V23L16 19L12 15V18Z',
      key: 'am1sw',
    },
  ],
]);

export default Sync;
